import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/betgalaxy/images/logo.svg';

export default function Index() {
  return <Image src={logo} ml="2" />;
}
